import SCHEMATIC_IMGS from "./SCHEMATIC_IMGS";






const SCHEMATIC_DATA = {



  traditional: {
    images: {
      vector: SCHEMATIC_IMGS.traditional,
    },
  },



};



export default SCHEMATIC_DATA;